import { InjectionToken } from "@angular/core";
import { ISessionStateService } from "./i-session-state.service";

export const sessionStateServiceInjectionToken: InjectionToken<ISessionStateService> = new InjectionToken<ISessionStateService>("digital-signage.user-dashboard.dashboard-web.SessionStateService");
